export default [
  { id: 1, value: 'Wisdom Tooth' },
  { id: 2, value: 'Abscess' },
  { id: 3, value: 'Swollen Face' },
  { id: 4, value: 'Lost Crown' },
  { id: 5, value: 'Broken FIlling' },
  { id: 6, value: 'Extraction' },
  { id: 7, value: 'Orthodontic Problem' },
  { id: 8, value: 'Failing Implant' },
  { id: 9, value: 'Facial Trauma' },
  { id: 10, value: 'Child' }
]
